module.exports = __webpack_public_path__ + "media/images/linkedin-1b6b7d01d5ff8f486edfe162e638eb3f.svg";